import React, { useRef, useState } from 'react';
import AvatarPhoto from '../AvatarPhoto';
import { usePhotoURL, uploadProfilePhoto, removeProfilePhoto } from '../profilePhoto';

/** Your avatar on Profile: click to add or change the photo. */
export default function ProfilePhotoEdit({ uid, initials }) {
  const input = useRef(null);
  const photo = usePhotoURL(uid);
  const [status, setStatus] = useState('');
  const [busy, setBusy] = useState(false);

  const choose = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    setBusy(true);
    setStatus('Checking your photo');
    try {
      await uploadProfilePhoto(uid, file);
      setStatus('');
    } catch (err) {
      setStatus(err.message);
    }
    setBusy(false);
  };

  return (
    <>
      <button type="button" className="pro-avatar-edit" onClick={() => input.current?.click()}
              disabled={busy} title={photo ? 'Change your photo' : 'Add a photo'} aria-label="Profile photo">
        <div className="pro-avatar">{initials}<AvatarPhoto uid={uid} /></div>
      </button>
      <input ref={input} type="file" accept="image/*" hidden onChange={choose} />
      {status && <div className="pro-photo-status" role="status">{status}</div>}
      {photo && !busy && !status && (
        <button type="button" className="pro-photo-remove" onClick={() => removeProfilePhoto(uid)}>Remove photo</button>
      )}
    </>
  );
}
